module.exports = __webpack_public_path__ + "img/KTB.6ebb3588.png";